import { render, staticRenderFns } from "./SrnStatusBar.vue?vue&type=template&id=b2438308&scoped=true&"
import script from "./SrnStatusBar.vue?vue&type=script&lang=js&"
export * from "./SrnStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./SrnStatusBar.vue?vue&type=style&index=0&id=b2438308&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2438308",
  null
  
)

export default component.exports